import { InteractionRequiredAuthError } from '@azure/msal-browser';
import { msalInstance, loginRequest } from '../configs/authConfig';

// Azure AD cannot be shown inside an iframe, so embedded pages sign in with a popup.
const isInIframe = () => window.self !== window.top;

// localStorage.clear() before the login was done by the old app as well (it also resets the PII warning).
export const login = () => {
    localStorage.clear();
    return msalInstance.loginRedirect(loginRequest).catch(console.error);
};

export const logout = () => msalInstance.logoutRedirect().catch(console.error);

export const getToken = async () => {
    const accounts = msalInstance.getAllAccounts();
    const request = {
        ...loginRequest,
        account: accounts[0],
    };

    try {
        const response = await msalInstance.acquireTokenSilent(request);
        return response.accessToken;
    } catch (e) {
        // Without an account the silent call cannot succeed either, so fall back to interaction.
        if (!(e instanceof InteractionRequiredAuthError) && accounts.length > 0) {
            throw new Error(`Auth fail with error: ${e}`);
        }

        if (isInIframe()) {
            const response = await msalInstance.acquireTokenPopup(request);
            return response.accessToken;
        }

        await msalInstance.loginRedirect(request);
        throw new Error('Redirecting to the login page');
    }
};

// Role claim of the access token (ALL, BUS or TRAIN); the API decides with it which lines the user may see.
export const getUserRole = async () => {
    const token = await getToken();
    try {
        const payload = token.split('.')[1].replace(/-/g, '+').replace(/_/g, '/');
        return JSON.parse(atob(payload)).roles?.[0] || 'ALL';
    } catch {
        return 'ALL';
    }
};
